import { TimeScaleComponent } from '@cgs/machines';

export function adjustDurationForTimeScale(
    timeScaleComponent: TimeScaleComponent,
    duration: number
): number {
    const scale = timeScaleComponent.timeScale;
    return scale > 0 ? duration / scale : duration;
}
